import userTypes from 'constants/userTypes';

export default {
  [userTypes.PARTNER]: 11,
  [userTypes.BENEFICIARY]: 1,
};
